import { rbp } from '@/constants/measured-scope'
import { MessageType, useAi } from '@/context/ai'
import { AIElementNames, eventsTracker } from '@/lib/eventsTracker'
import Field from '@/widgets/Field'
import { useMediaQuery } from '@react-hookz/web'
import { useRouter } from 'next/router'
import { useState } from 'react'
import * as styles from './style'

const SEARCH_PREFIX = 'Searching for'

const AiSearchBox = (): JSX.Element => {
  const router = useRouter()
  const { dispatch } = useAi()
  const [searchQuery, setSearchQuery] = useState('')

  const handleSubmit = (): void => {
    if (!searchQuery.trim()) return
    eventsTracker.handleOnClickAndTrackEvent(AIElementNames.BUTTON_SEND_MESSAGE)
    dispatch({
      type: 'UPDATE',
      payload: { query: `${SEARCH_PREFIX} ${searchQuery}`, messageType: MessageType.UserFreeText },
    })
    router.push(`/helen`)
  }

  return (
    <div>
      <Field className={styles.searchField} id="search" icon="search" noBorder iconSize={20}>
        <input
          autoComplete="off"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
          className="h-10 w-60 pr-0 py-0"
        />
      </Field>
    </div>
  )
}
export default AiSearchBox
